<div class='backgroundImg'></div>

<div class="parkingpass-main-holder" id="parkingpassMainHolder">

    <app-menu-logged-out class="parkingpass-app-menu"></app-menu-logged-out>

</div>